export default {"src":"/_next/static/media/logo-shab-dark.2e20993c.svg","height":66,"width":199,"blurWidth":0,"blurHeight":0};